import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useRouteHistory = () => {
  const location = useLocation();

  useEffect(() => {
    // Get current route
    const currentRoute = location.pathname;
    
    // Get the previous route from session storage
    const previousRoute = sessionStorage.getItem('currentRoute');
    
    // Valid routes that should be stored as navigation history
    const validRoutes = [
      '/',
      '/apnaeduhub',
      '/hotel-management',
      '/ecommerce'
    ];
    
    // Check if current route is valid (not a 404 or admin route)
    const isValidRoute = validRoutes.includes(currentRoute) || 
                        currentRoute.startsWith(`/${import.meta.env.VITE_ADMIN_MENU_PATH || 'admin'}/`) ||
                        (currentRoute !== '/404' && currentRoute !== '*' && !currentRoute.includes('undefined'));
    
    // Store the current route as previous route for next navigation
    if (previousRoute && previousRoute !== currentRoute && isValidRoute) {
      sessionStorage.setItem('previousRoute', previousRoute);
    }
    
    // Update current route in session storage
    if (isValidRoute) {
      sessionStorage.setItem('currentRoute', currentRoute);
      sessionStorage.setItem('lastValidRoute', currentRoute);
    }
    
    // Initialize session storage if empty
    if (!sessionStorage.getItem('lastValidRoute')) {
      sessionStorage.setItem('lastValidRoute', '/');
    }
    
    // Clean up invalid routes from session storage
    const storedPrevious = sessionStorage.getItem('previousRoute');
    if (storedPrevious && !validRoutes.includes(storedPrevious) && !storedPrevious.startsWith(`/${import.meta.env.VITE_ADMIN_MENU_PATH || 'admin'}/`)) {
      sessionStorage.setItem('previousRoute', '/');
    }
    
  }, [location.pathname]);
};

export default useRouteHistory;
